/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coaches_Page_Chip_FreeInputs */

const en_coaches_page_chip_free = /** @type {(inputs: Coaches_Page_Chip_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} free hours today`)
};

const pl_coaches_page_chip_free = /** @type {(inputs: Coaches_Page_Chip_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wolnych godzin dziś`)
};

/**
* | output |
* | --- |
* | "{count} free hours today" |
*
* @param {Coaches_Page_Chip_FreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_chip_free = /** @type {((inputs: Coaches_Page_Chip_FreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Chip_FreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_chip_free(inputs)
	return en_coaches_page_chip_free(inputs)
});